module.exports = __webpack_public_path__ + "img/infohob-blue-logo-2.07b69318.svg";